import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AppsettingsConfig } from '../../modules/client-config/models/client-config';
import AccountUserInfo from '../models/AccountUserInfo';

export const INIT_REQUEST_HEADER = 'X-Init-Request';

@Injectable({ providedIn: 'root' })
export class UserInitService {
  private userInfo: AccountUserInfo | null = null;

  constructor(
    private http: HttpClient,
    private config: AppsettingsConfig
  ) {}

  getUserInfo(): AccountUserInfo | null {
    return this.userInfo;
  }

  async loadUserInfo(): Promise<void> {
    const currentPath = window.location.pathname;
    if (
      currentPath.includes('/esia-token-and-scope') ||
      currentPath.includes('/specialists-signin') ||
      currentPath.includes('/auth/confirm')
    ) {
      this.userInfo = null;
      return Promise.resolve();
    }

    const url = `${this.config.backendUrl}/account/UserInfo`;

    try {
      const result = await this.http
        .post<AccountUserInfo>(url, {}, {
          withCredentials: true,
          headers: { [INIT_REQUEST_HEADER]: 'true' }
        })
        .toPromise();

      this.userInfo = result ?? null;
    } catch (error: unknown) {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401 || error.status === 403 || error.status === 406) {
          this.userInfo = null;
          return;
        }
      }
      console.error('Failed to load user info:', error);
      this.userInfo = null;
    }
  }
}
